import { Injectable } from "@angular/core";
import {  ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LangGuardService {
  constructor(
    private translate: TranslateService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
    const lang = route.paramMap.get('lang');
    // 設定i18n
    // this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    return true;
  }
}